import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import type {
  ScoutingCenterQuery,
  ScoutingCenterQueryVariables,
} from './__generated__/useScoutingCenterSo5Fixture.graphql.ts';

const USE_SCOUTING_CENTER_QUERY = gql`
  query ScoutingCenterQuery($sport: Sport!) {
    so5 {
      so5Fixture(type: UPCOMING, eventType: CLASSIC, sport: $sport) {
        id
        slug
      }
    }
  }
` as TypedDocumentNode<ScoutingCenterQuery, ScoutingCenterQueryVariables>;

export const useScoutingCenterSo5Fixture = (sport: Sport) => {
  const { data } = useQuery(USE_SCOUTING_CENTER_QUERY, {
    variables: { sport },
  });

  return data?.so5.so5Fixture?.slug || '';
};
